import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IntegrationTokenDelegationListResponse } from '@zerops/models/integration-token';

@Injectable({ providedIn: 'root' })
export class IntegrationTokenDelegationApi {
  #httpClient = inject(HttpClient);

  // Client-wide list of all delegations across the client's integration tokens.
  // Powers the "has delegations" indicator in the token list.
  listAll$(clientId: string): Observable<IntegrationTokenDelegationListResponse> {
    return this.#httpClient.get<IntegrationTokenDelegationListResponse>(
      `/api/client/${clientId}/integration-token/delegation`
    );
  }

  // Scoped list of a single token's delegations — used by the edit dialog so it
  // doesn't pull every delegation on the client (clients can have hundreds).
  listForToken$(clientId: string, tokenId: string): Observable<IntegrationTokenDelegationListResponse> {
    return this.#httpClient.get<IntegrationTokenDelegationListResponse>(
      `/api/client/${clientId}/integration-token/${tokenId}/delegation`
    );
  }
}
